const zh = {
  translation: {
    site: {
      name: '蘑菇影视',
      slogan: '高清免费在线观看',
      search: '搜索影片...',
    },
    nav: {
      home: '首页',
      movies: '电影',
      tvShows: '电视剧',
      variety: '综艺',
      anime: '动漫',
      about: '关于我们',
    },
    home: {
      heroTitle: '海量影视，免费观看',
      heroSubtitle: '电影、电视剧、综艺、动漫 — 高清流畅不缓冲',
      heroCta: '开始观看',
      hotRecommend: '热门推荐',
      newArrival: '最新上线',
      allMovies: '全部影片',
      viewAll: '查看全部',
    },
    category: {
      movies: '电影',
      tvShows: '电视剧',
      variety: '综艺',
      anime: '动漫',
      all: '全部',
      filterByType: '按类型筛选',
      sortBy: '排序方式',
      newest: '最新',
      hottest: '最热',
      rating: '评分最高',
    },
    article: {
      director: '导演',
      actors: '主演',
      duration: '时长',
      region: '地区',
      type: '类型',
      description: '剧情简介',
      relatedRecommend: '相关推荐',
      episodes: '集数',
      updateStatus: '更新状态',
    },
    about: {
      title: '关于蘑菇影视',
      brandIntro: '品牌介绍',
      reputation: '口碑评价',
      contact: '联系我们',
      brandDesc: '蘑菇影视成立于2020年，是国内领先的高清在线视频播放平台。我们致力于为用户提供最优质的影视内容服务，涵盖电影、电视剧、综艺、动漫等多个品类，拥有海量正版高清资源库。',
      mission: '让每个人都能轻松享受高品质影视内容，是蘑菇影视始终坚持的使命。',
      contactEmail: 'contact@mogutv.com',
      contactPhone: '400-888-0000',
      contactAddress: '北京市朝阳区望京科技园A座',
    },
    footer: {
      copyright: '© 2026 蘑菇影视 版权所有',
      privacy: '隐私政策',
      terms: '服务条款',
      disclaimer: '本站所有视频内容均来自互联网，仅供学习交流使用。',
    },
    common: {
      rating: '评分',
      play: '播放',
      detail: '详情',
      loading: '加载中...',
      noMore: '没有更多了',
      backToTop: '返回顶部',
      breadcrumbHome: '首页',
    },
  },
};

export default zh;